import type { AnyError } from "#public"
import type { Result } from "#public"

// Collapse a result to a plain `T`: on success return the value, on failure run
// `error` to recover a `T` from the error. Unlike `ResultMap`, both branches
// yield the same `T`, so there's no `Result` wrapper left.
export const ResultResolve = <T, E extends AnyError>(
  result: Result<T, E>,
  error: (e: E) => T
): T => (result.error ? error(result.error) : (result.value as T))
